import { render, staticRenderFns } from "./pcAbout.vue?vue&type=template&id=4ee98640"
import script from "./pcAbout.vue?vue&type=script&lang=js"
export * from "./pcAbout.vue?vue&type=script&lang=js"
import style0 from "./pcAbout.vue?vue&type=style&index=0&id=4ee98640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports